<script setup lang="ts">
import { computed, ref, watchEffect } from "vue";
import { useI18n } from "vue-i18n";

enum AffiliateTypesEnum {
	ADMIN = "ADMIN",
	TECHNICAL = "TECHNICAL",
	MANAGER = "MANAGER",
	ASSISTANT = "ASSISTANT",
}

import {
	baseInput,
	baseSelect,
	baseTextarea,
	svgIcon,
} from "@/common/components";

const { t } = useI18n();

const emit = defineEmits(["update-data"]);

const props = defineProps<{
	data?: any;
	title?: string;
}>();

const defaultData = {
	description: "",
	email: "",
	name: "",
	type: "",
	status: "ACTIVE",
};

const affiliateOptions = computed(() => [
	{
		option: "ADMINISTRADOR",
		value: "ADMIN",
	},
	{
		option: "TÉCNICO",
		value: "TECHNICAL",
	},
	{
		option: "GERENTE",
		value: "MANAGER",
	},
	{
		option: "ASSISTENTE",
		value: "ASSISTANT",
	},
]);

const statusOptions = computed(() => [
	{
		option: t("common.labels.active"),
		value: "ACTIVE",
	},
	{
		option: t("common.labels.inactive"),
		value: "INACTIVE",
	},
]);

const payload = ref<any>({ ...defaultData });

const disabled = ref(false);

function update() {
	emit("update-data", payload.value);
}

watchEffect(async () => {
	if (props.data) {
		const { status, member_id, description, email, name, type } = props.data;

		payload.value = {
			status,
			member_id,
			description,
			email,
			name,
			type,
		};

		disabled.value = true;
	}
});
</script>

<template>
	<section class="technical-form">
		<template v-if="title">
			<div class="title">
				<svg-icon icon="technical" size="2.5rem" />
				{{ title }}
			</div>
		</template>

		<form>
			<div class="flex flex-row gap-2">
				<base-select
					v-model="payload.type"
					:value="payload.type"
					:options="affiliateOptions"
					:required="true"
					:is-empty="false"
					@change="update()"
				>
					<template #label>
						{{ t("common.labels.type") }}
					</template>
				</base-select>

				<base-select
					v-model="payload.status"
					:value="payload.status"
					:options="statusOptions"
					:required="true"
					:is-empty="false"
					@change="update()"
				>
					<template #label>
						{{ t("common.labels.type") }}
					</template>
				</base-select>
			</div>

			<base-input
				v-model="payload.name"
				:value="payload.name"
				:placeholder="t('common.placeholders.name')"
				:disabled="disabled"
				:required="true"
				@blur="update()"
			>
				<template #label>
					{{ t("common.labels.name") }}
				</template>
			</base-input>

			<base-input
				v-model="payload.email"
				:value="payload.email"
				:placeholder="t('common.placeholders.email')"
				:disabled="disabled"
				:required="true"
				@blur="update()"
			>
				<template #label>
					{{ t("common.labels.email") }}
				</template>
				<template #sufix>
					<svg-icon icon="email" />
				</template>
			</base-input>

			<base-textarea
				v-model="payload.description"
				:value="payload.description"
				:placeholder="t('common.placeholders.describe')"
				:disabled="disabled"
				@blur="update()"
			>
				<template #label>
					{{ t("common.labels.description") }}
				</template>
			</base-textarea>
		</form>
	</section>
</template>

<style lang="scss" scoped>
.technical-form {
	display: flex;
	flex-direction: column;
	gap: 1.25rem;

	.title {
		display: inline-flex;
		align-items: center;
		gap: 1rem;
		font-size: 1.5rem;
		font-weight: bold;
		text-transform: uppercase;
	}

	form {
		display: flex;
		flex-direction: column;
		gap: 1.25rem;
	}
}
</style>
